import React,{useEffect,useState} from 'react'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import { directUrl, homePageUrl } from '../../../helpers/Constants'
import { useParams,useLocation,useNavigate } from 'react-router-dom'
import { requestApi } from '../../../request-api'

function CompliancerLegislationListView() {
 let [legislation,setLegislation]=useState([])
 let [legislationName,setLegislationName] = useState([])
 let {reportId} =  useParams()
 const location = useLocation();
 let navigate = useNavigate()
 console.log(reportId)
 console.log(reportId)
    const getComplianceData =()=>{
        
        requestApi(`/compliancer/getLegislationByReport/${reportId}`,{
            method:'get'
        }).then((data)=>{
            console.log("first",data.data)
            setLegislation(data.data)
            let legName =[]
            data.data.map((leg)=>{
                legName.push(leg.legislation_name)
            })
            setLegislationName(legName)
        }).catch(error =>{console.log(error)})



    }
 useEffect(()=>{
    
        getComplianceData()

 },[])
  return (
    <section className='lyt-section'>
        <Container fluid className='typ-container'>
        <Breadcrumb className='bs-breadcrumb mt-0'>
                <BreadcrumbItem><NavLink to={`${directUrl}compliancer/reports`}>Reports</NavLink></BreadcrumbItem>
                <BreadcrumbItem>{location.state.row.report_id}</BreadcrumbItem>
                <BreadcrumbItem active>Legislation</BreadcrumbItem>
            </Breadcrumb>
            <Row>
                <Col xs={12} sm={12} md={12} lg={9} xl={8}>
                    <ul className='bs-list'>
                        {legislation.map((leg)=>(
                           <li><NavLink 
                           onClick={(e) => {
                            e.preventDefault();
                            navigate(
                              `${directUrl}compliancer/view/legislation-list/${reportId}/${leg.id}`,
                              { state: { leg: leg, row: location.state.row } }
                            );
                          }}
                          >{leg.legislation_name} </NavLink></li> 
                        ))}                     
                    </ul>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default CompliancerLegislationListView
